<template>
<div>
	<div class="row">

		<div class="col-12">
			<partial-loader :loading="isFetching"></partial-loader>
		</div>

		<div class="col-12"
		     v-if="!isFetching">

			<b-alert v-if="formError.errors"
			         show
			         variant="warning">
				<span v-for="errors in formError.errors">
 						<span v-for="error in errors">{{ error }}<br /></span>
				</span>
			</b-alert>

			<b-jumbotron class="mb-3 p-4">
				<h1 class="display-4">{{ $t('item.setAuctionOrderNumbersTitle') }}</h1>

				<b-form @submit.prevent="setAuctionOrderNumber"
				        class="mb-3">

					<div class="row">
						<div class="col-3">
							<autocomplete-category :label="$t('item.category')"
							                       @update:category="updateCategoryId"></autocomplete-category>
						</div>
						<div class="col-3">
							<b-form-group :label="$t('item.startNumber')">
								<b-form-input type="number"
								              step="1"
											  autocomplete="off"
								              v-model="form.start_number">
								</b-form-input>
							</b-form-group>
						</div>
					</div>

					<div class="row">
						<div class="col">
							<b-btn variant="primary"
							       type="submit">
								<i class="fa fa-list-ol"
								   aria-hidden="true"></i> {{ $t('item.setAuctionOrderNumbers') }}
							</b-btn>
						</div>
					</div>
				</b-form>
			</b-jumbotron>

		</div>

	</div>

</div>
</template>

<script>
import { isNil } from 'lodash';
import AuctionService from '@/services/auction-service';
import PartialLoader from '@/components/elements/PartialLoader';
import AutocompleteCategory from '@/components/elements/AutocompleteCategory';
import { flashSuccess } from '@/helpers/flash-message-helper';

export default {
	components: {
		PartialLoader,
		AutocompleteCategory
	},
	data() {
		return {
			isFetching: false,
			formError: false,
			form: {
				start_number: '',
				category_id: ''
			}
		}
	},
	methods: {
		setAuctionOrderNumber() {
			this.formError = false;
			this.isFetching = true;
			return AuctionService.setAuctionOrderNumber(this.$route.params.auctionId, this.form).then(response => {
				this.isFetching = false;
				this.formError = false;
				this.form.start_number = '';
				this.form.category_id = '';
				flashSuccess(this.$t('item.auctionOrderNumberSuccess'));
			}).catch(error => {
				this.isFetching = false;
				this.formError = error.response.data;
			});
		},
		updateCategoryId(category) {
			if (!isNil(category))
				this.form.category_id = category.id;
		}
	},
	mounted() {
		//this.fetchPerson();
	}
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// ItemOrder.vue?4c1f43dc